import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccountPaymentMethodList,
  getAccountPaymentMethodById,
  createAccountPaymentMethod,
  updateAccountPaymentMethod,
  deleteAccountPaymentMethod,
} from "api/accountPaymentMethodApi"

export const ACCOUNT_PAYMENT_METHOD_QUERY_KEY = "account-payment-method"

export const useAccountPaymentMethods = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_PAYMENT_METHOD_QUERY_KEY,
    getAccountPaymentMethodList,
    params,
    enabled
  )
}

export const useAccountPaymentMethod = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_PAYMENT_METHOD_QUERY_KEY,
    getAccountPaymentMethodById,
    id,
    enabled
  )
}

export const useCreateAccountPaymentMethod = () => {
  return useCreateResource(
    createAccountPaymentMethod,
    ACCOUNT_PAYMENT_METHOD_QUERY_KEY
  )
}

export const useEditAccountPaymentMethod = () => {
  return useEditResource(
    updateAccountPaymentMethod,
    ACCOUNT_PAYMENT_METHOD_QUERY_KEY
  )
}

export const useDeleteAccountPaymentMethod = () => {
  return useDeleteResource(
    deleteAccountPaymentMethod,
    ACCOUNT_PAYMENT_METHOD_QUERY_KEY
  )
}
